import { render, staticRenderFns } from "./AdmissionIcon.vue?vue&type=template&id=72cb30d4"
import script from "./AdmissionIcon.vue?vue&type=script&lang=js"
export * from "./AdmissionIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports